document.addEventListener('DOMContentLoaded', function () {
    // Function to scroll to the top of the page
    function scrollToTop() {
      console.log('Scroll to top button clicked');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  
    // Function to show or hide the scroll-to-top button
    function toggleScrollButton() {
      const scrollButton = document.getElementById('scrollToTopBtn');
      const scrollPercentage = 20; // Show button after 20% scroll
  
      if (window.scrollY > (document.documentElement.scrollHeight * scrollPercentage / 100)) {
        scrollButton.style.display = 'flex';
        console.log('Scroll button shown');
      } else {
        scrollButton.style.display = 'none';
        console.log('Scroll button hidden');
      }
    }
  
    // Add event listener for scroll events
    window.addEventListener('scroll', toggleScrollButton);
  
    // Initialize button state on page load
    toggleScrollButton();
  
    // Add event listener for the scroll-to-top button
    const scrollToTopBtn = document.getElementById('scrollToTopBtn');
    if (scrollToTopBtn) {
      scrollToTopBtn.addEventListener('click', scrollToTop);
    } else {
      console.error('Scroll to top button not found');
    }
  });
  